export default __webpack_public_path__ + "static/media/logo.6b2775f2.svg";